import headers from "app/requests/headers";
import queryString from "app/requests/query-string";

export const get = (uid) => (
  fetch(`/api/preview/episodes/${uid}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const getAll = (params) => (
  fetch(`/api/preview/episodes?${queryString(params || {})}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);
